(function () {
    'use strict';

    angular
        .module('tfc.retailer.Filter')
        .factory('HierarchyFilter', HierarchyFilterClass);

    function HierarchyFilterClass(BaseFilter) {

        function HierarchyFilter(attributeHierarchies, hierarchyParam, departmentParam, categoryParam) {
            if (!(this instanceof HierarchyFilter)) return new HierarchyFilter(attributeHierarchies, hierarchyParam, departmentParam, categoryParam);

            BaseFilter.call(this, 'Category Filter');
            setData.call(this,attributeHierarchies, hierarchyParam, departmentParam, categoryParam);
        }

        HierarchyFilter.prototype = _.create(BaseFilter.prototype, {
            getOptionString: getOptionString,
            isVisible: isVisible
        });

        return HierarchyFilter;

        function setData(attributeHierarchies, hierarchyParam, departmentParam, categoryParam) {
            var data = _(attributeHierarchies).map(function (o) {
                return {
                    department: o.department,
                    category: o.category,
                    display: o.category ? o.department + " " + o.category : o.department
                }
            }).value();

            BaseFilter.prototype.setData.call(this,data);
            onLoad.call(this, departmentParam, categoryParam);
        }

        function getOptionString() {
            return 'hierarchy as hierarchy.display for hierarchy in vm.data';
        }

        function isVisible() {
            return true;
        }

        function onLoad(departmentParam, categoryParam) {
            var data = this.getData();
            var selectedItem;

            selectedItem = departmentParam == null && categoryParam == null ? data[0] : _.find(data, {
                department: departmentParam,
                category: categoryParam
            });

            this.setSelectedItem(selectedItem);
        }
    }

}());